import React, { useState } from "react";
import { useTranslation } from "@1f/react-sdk";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";
import Stack from "@vapor/react-material/Stack";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import ExtendedTabs from "@vapor/react-extended/ExtendedTabs";
import ExtendedTab from "@vapor/react-extended/ExtendedTab";
import { DataGridPro, GridToolbar, itIT } from "@mui/x-data-grid-pro";
import { NoData } from "../../../components/NoData";

export const DashboardExpirations = ({
  anagDocInScadList,
  anagDocInScadListColumns,
  rischiList,
  rischiColumns,
  autovalList,
  autovalColumns,
  onGoToAnagrafica,
  onGoToRischio,
}) => {
  const { t } = useTranslation();
  const [selectedScadTab, setSelectedScadTab] = useState("tabDocumenti");

  const handleChangeScadTab = (event, newValue) => {
    setSelectedScadTab(newValue);
  };

  return (
    <Card sx={{ width: "50%", minWidth: 0 }}>
      <CardContent sx={{ p: { xs: 2, md: 4 } }}>
        <Stack direction="column" spacing={1}>
          <ExtendedTypography variant="titleSmall" color="primary.main" gutterBottom>
            {t("dashboard.nxtExp")} (
            {anagDocInScadList.length + rischiList.length + autovalList.length}
            )
          </ExtendedTypography>

          <ExtendedTabs
            variant="standard"
            size="small"
            value={selectedScadTab}
            onChange={handleChangeScadTab}
            sx={{ mb: 2 }}
          >
            <ExtendedTab value="tabDocumenti" label={t("dashboard.label3")} />
            <ExtendedTab value="tabContCost" label={t("dashboard.label4")} />
            <ExtendedTab value="tabAutoval" label="Autovalutazioni" />
          </ExtendedTabs>

          {selectedScadTab === "tabDocumenti" ? (
            <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
              {anagDocInScadList.length > 0 ? (
                <DataGridPro
                  rows={anagDocInScadList}
                  columns={anagDocInScadListColumns}
                  slots={{ toolbar: GridToolbar }}
                  autoHeight={true}
                  pageSizeOptions={[5]}
                  localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                  pagination
                  disableRowSelectionOnClick
                  onRowClick={(item, e) => onGoToAnagrafica(e, item.row)}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        id: false,
                      },
                    },
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                    },
                  }}
                />
              ) : (
                <NoData size="small" />
              )}
            </Stack>
          ) : null}

          {selectedScadTab === "tabContCost" ? (
            <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
              {rischiList.length > 0 ? (
                <DataGridPro
                  rows={rischiList}
                  columns={rischiColumns}
                  slots={{ toolbar: GridToolbar }}
                  autoHeight={true}
                  pageSizeOptions={[5, 10, 15]}
                  localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                  pagination
                  disableRowSelectionOnClick
                  onRowClick={(item, e) => onGoToRischio(e, item.row)}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        id: false,
                      },
                    },
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                    },
                  }}
                />
              ) : (
                <NoData size="small" />
              )}
            </Stack>
          ) : null}

          {selectedScadTab === "tabAutoval" ? (
            <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
              {autovalList.length > 0 ? (
                <DataGridPro
                  rows={autovalList}
                  columns={autovalColumns}
                  slots={{ toolbar: GridToolbar }}
                  autoHeight={true}
                  pageSizeOptions={[5, 10, 15]}
                  localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                  pagination
                  disableRowSelectionOnClick
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        id: false,
                      },
                    },
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                    },
                  }}
                />
              ) : (
                <NoData size="small" />
              )}
            </Stack>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  );
};
